import { questionnaireSectionApi } from '@/lib/api/questionnaireApi';
import { handleDeleteError } from '@/lib/queryErrorHandler';
import { QuestionnaireSectionProps } from '@/types/questionnaire';
import { router } from '@inertiajs/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useDeleteSectionMutation({
  section,
  onClose,
  onSuccess,
}: {
  section: QuestionnaireSectionProps;
  onClose: () => void;
  onSuccess?: () => void;
}) {
  const queryClient = useQueryClient();

  const deleteSectionMutation = useMutation({
    mutationFn: () => questionnaireSectionApi.delete(section.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['template', section.questionnaire_template_id],
      });

      router.reload({ only: ['template'] });

      toast.success('Section deleted successfully');
      onSuccess?.();
      onClose();
    },
    onError: (error) => handleDeleteError(error, 'section'),
  });

  const handleDelete = () => {
    deleteSectionMutation.mutate();
  };

  return {
    deleteSectionMutation,
    handleDelete,
  };
}
